import React from "react";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

// Custom styled chip for warning with orange text
const WarningChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#2d2d00" : "#fffde7",
  color: "#E6A700", // Darker gold/orange color
  fontWeight: "bold",
  border: "1px solid #FFC700",
  "& .MuiChip-label": {
    color: "#E6A700", // Matching darker gold/orange color
  },
}));

export function renderAlarm(value, t) {
  // Display the numeric value in the chip
  return <Chip label={value} color="error" sx={{ minWidth: "40px" }} />;
}

export function renderWarning(value, t) {
  // Display the numeric value in the chip using custom styled chip
  return <WarningChip label={value} sx={{ minWidth: "40px" }} />;
}

export function renderOffline(value, t) {
  return <Chip label={t("dashboard.statusChip.offline")} color="error" />;
}

export function renderAlarmm(value, t) {
  return <Chip label={t("dashboard.statusChip.alarm")} color="error" />;
}

export function renderWarningg(value, t) {
  return <WarningChip label={t("dashboard.statusChip.warning")} />;
}

export function renderNormal(value, t) {
  return <Chip label={t("dashboard.statusChip.normal")} color="success" />;
}

// Gray version of the normal status chip
export function renderNormalGray(value, t) {
  return (
    <Chip
      label={t("dashboard.statusChip.normal")}
      variant="filled"
      color="default"
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "dark" ? "#424242" : "#eeeeee",
        color: (theme) =>
          theme.palette.mode === "dark" ? "#e0e0e0" : "#424242",
        border: "1px solid",
        borderColor: "divider",
        minWidth: "40px",
        fontWeight: "bold",
      }}
    />
  );
}

export function renderHigh(value, t) {
  return <Chip label={t("alarmHistory.veryHigh")} color="error" />;
}

export function renderOther(value, t) {
  return <Chip label={t("alarmHistory.on")} color="info" />;
}

export function renderAvatar(params) {
  if (params.value == null) {
    return "";
  }

  return (
    <Avatar
      sx={{
        backgroundColor: params.value.color,
        width: "24px",
        height: "24px",
        fontSize: "0.85rem",
      }}
    >
      {params.value.name.toUpperCase().substring(0, 1)}
    </Avatar>
  );
}

export { WarningChip };
